import { NavLink } from "react-router-dom";
import { ProblemError } from "@csa/web-foundation";
import { useT } from "../../i18n/index";
import { Icon } from "../../ui/icons";
import { useMyBook } from "../household/use-household";

const fmt = (iso: string) =>
  new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

// CONSOLE-WIRE-3 — My Book. The advisor's own household book (GET /v1/advisors/me/book),
// scope-filtered by the API. Each row links into the Müşteri 360. Loading/empty/error states.
export function MyBook() {
  const { t } = useT();
  const q = useMyBook();

  if (q.isLoading)
    return (
      <div className="k-loading">
        <div className="k-loading__head">
          <span className="k-loading__spinner" />
          <span className="k-loading__label">{t("book.loading")}</span>
        </div>
      </div>
    );
  if (q.error)
    return (
      <div className="k-note k-note--error">
        <div className="k-note__row">
          <span className="k-note__icon k-note__icon--error">
            <Icon name="alert-triangle" size={20} />
          </span>
          <p role="alert" className="k-note__desc" data-testid="book-error">
            {q.error instanceof ProblemError ? q.error.problem.detail : t("book.error")}
          </p>
        </div>
      </div>
    );

  const rows = q.data ?? [];
  return (
    <section className="surface my-book" data-testid="my-book">
      <header className="surface__head">
        <div>
          <h1 className="surface__title">{t("book.title")}</h1>
        </div>
      </header>
      {rows.length === 0 ? (
        <div className="k-empty" data-testid="book-empty">
          <div className="k-empty__icon">
            <Icon name="household" size={26} />
          </div>
          <p className="k-empty__title">{t("book.empty")}</p>
        </div>
      ) : (
        <ul className="book-list">
          {rows.map((h) => (
            <li
              key={h.id}
              className="k-card k-card--pad-sm book-row"
              data-testid={`book-row-${h.id}`}
            >
              <span className="k-avatar">{initials(h.name)}</span>
              <div className="book-row__main">
                <NavLink to={`/households/${h.id}`} className="book-link">
                  {h.name}
                </NavLink>
              </div>
              <span className="k-chip">
                <Icon name="calendar" size={14} />
                {t("book.since")} {fmt(h.ownerSince)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
